import React, { useState,useEffect } from "react";
import "./WashingMachineService.css";
import fullyautomic from "../images/fullyautomatic.webp";
import semi from "../images/semi.webp";
import washingins from "../images/washing ins.webp";
import drum from "../images/drum.webp"
import wmmaintan from "../images/wmmaintain.webp";
import wmdoor from "../images/wm door.webp";
import washingrepair from "../images/washing repair.webp";
import customer from "../images/cutomer1.webp";

function WashingMachineService() {
    useEffect(() => {

    document.title =
      "Washing Machine Service - Embarque Services";

  }, []);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    location: "",
    issue: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    const sendData = {
      ...formData,
      toMail: "expresshelplinecare@gmail.com",
    };

    try {

      const res = await fetch(
        "https://form.e2ecrm.in/api/sendmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData),
        }
      );

      await res.json();

      alert(
        "Thank you! Your service request is confirmed. Our engineer will call you shortly."
      );

      setFormData({
        name: "",
        phone: "",
        location: "",
        issue: "",
      });

    } catch (err) {

      console.log(err);

      alert("Error sending form");

    } finally {

      setLoading(false);

    }
  };

  return (
    <>

  

      {/* SPINNER */}

      {loading && (

        <div className="spinner-overlay">

          <div className="spinner"></div>

        </div>

      )}

      <div className="washing-machine-home">

        {/* HERO SECTION */}

        <section className="washing-hero">

          {/* LEFT APPLIANCE */}

          <div className="washing-appliance-section">

            {/* <img
              className="washing-machine-img"
              src="https://cdn-icons-png.flaticon.com/512/1046/1046850.png"
              alt="Washing Machine"
            /> */}

          </div>

          {/* CONTENT */}

          <div className="washing-content">

            <h1>
              Washing Machine <br />
              Repair & Service <br />
              At Your <br />
              Doorsteps
            </h1>

          </div>

          {/* FORM */}

          <div className="washing-booking-form">

            <h2>
              +91 93639 29984
            </h2>

            <p>
              CALL US TODAY
            </p>

            <span>
              Register your washing machine complaints
            </span>

            <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />

              <input
                type="text"
                name="location"
                placeholder="Location"
                value={formData.location}
                onChange={handleChange}
                required
              />

              <textarea
                name="issue"
                placeholder="Describe the washing machine issue..."
                value={formData.issue}
                onChange={handleChange}
              ></textarea>
          <p>Your personal information is handled responsibly and used only for the services you request.</p>

              <button type="submit">

                {loading ? "Sending..." : "SUBMIT"}

              </button>

            </form>

          </div>

        </section>

      </div>




{/* Washing Machine About Section */}

<section className="washing-about-section">

  {/* Left Content */}

  <div className="washing-about-left">

    <h1>
      Trusted Washing <br />
      Machine Repair <br />
      Experts for <br />
      Your Home <br />
      Needs
    </h1>

    <div className="washing-about-box">

      <p>
        With 8+ years of experience in washing machine repair and maintenance,
        our  Experienced Technicians  provide fast and reliable doorstep solutions.
      </p>

      <p>
        From fully automatic to semi automatic washing machines,
        we fix all major brand issues quickly at affordable pricing.
      </p>

    </div>

  </div>

  {/* Right Counter */}

  <div className="washing-about-right">

    <h4>
      OUR SERVICE ACHIEVEMENTS
    </h4>

    <div className="washing-counter-grid">

      <div className="washing-counter-box">
        <h1>8+</h1>
        <p>Years Experience</p>
      </div>

      <div className="washing-counter-box">
        <h1>40000+</h1>
        <p>Machines Repaired</p>
      </div>

      <div className="washing-counter-box">
        <h1>60+</h1>
        <p> Experienced Technicians </p>
      </div>

      <div className="washing-counter-box">
        <h1>20+</h1>
        <p>Multiple Service Areas Covered</p>
      </div>

    </div>

  </div>

</section>


{/* Washing Machine Services Section */}

<section className="washing-services-section">

  <h1 className="washing-service-title">
    Our Washing Machine Services
  </h1>

  <div className="washing-services-grid">

    {/* Card 1 */}

    <div className="washing-service-card">

      <img
        src={fullyautomic}
        alt="fully automatic"
      />

      <h2>
        Fully Automatic Repair
      </h2>

      <p>
        Complete repair solutions for fully automatic washing machines
        including spin, drainage, and motor issues.
      </p>

    </div>

    {/* Card 2 */}

    <div className="washing-service-card">

      <img
        src={semi}
        alt="semi automatic"
      />

      <h2>
        Semi Automatic Service
      </h2>

      <p>
        Professional servicing and maintenance support for semi automatic
        washing machines of all major brands.
      </p>

    </div>

    {/* Card 3 */}

    <div className="washing-service-card">

      <img
        src={washingins}
        alt="installation"
      />

      <h2>
        Installation Support
      </h2>

      <p>
        Safe and professional washing machine installation and setup
        support at your doorstep.
      </p>

    </div>

    {/* Card 4 */}

    <div className="washing-service-card">

      <img
        src={drum} alt="drum repair"
      />

      <h2>
        Drum & Motor Repair
      </h2>

      <p>
        Expert repair solutions for noisy drum, motor failure,
        vibration, and spinning problems.
      </p>

    </div>

    {/* Card 5 */}

    <div className="washing-service-card">

      <img
        src={wmmaintan}        alt="maintenance"
      />

      <h2>
        Maintenance Service
      </h2>

      <p>
        Regular maintenance support to improve washing machine performance
        and increase product life.
      </p>

    </div>

    {/* Card 6 */}

    <div className="washing-service-card">

      <img
        src={wmdoor}
        alt="doorstep"
      />

      <h2>
        Doorstep Repair
      </h2>

      <p>
        Fast doorstep washing machine repair support by experienced
        technicians at affordable pricing.
      </p>

    </div>

  </div>

</section>

{/* WASHING MACHINE WHY CHOOSE US */}

<section className="washing-choose-section">

  <div className="washing-choose-overlay">

    <h4>
      WHY CHOOSE OUR SERVICE
    </h4>

    <h1>
      Trusted Washing Machine <br />
      Repair Solutions
    </h1>

    <div className="washing-choose-grid">

      {/* BOX 1 */}

      <div className="washing-choose-box">

        <div className="washing-choose-icon">
          🛠️
        </div>

        <h2>
          Expert Repair Service
        </h2>

      </div>

      {/* BOX 2 */}

      <div className="washing-choose-box">

        <div className="washing-choose-icon">
          ⏰
        </div>

        <h2>
          Same Day Support
        </h2>

      </div>

      {/* BOX 3 */}

      <div className="washing-choose-box">

        <div className="washing-choose-icon">
          💰
        </div>

        <h2>
          Affordable Pricing
        </h2>

      </div>

      {/* BOX 4 */}

      <div className="washing-choose-box">

        <div className="washing-choose-icon">
          🚚
        </div>

        <h2>
          Doorstep Service
        </h2>

      </div>

      {/* BOX 5 */}

      <div className="washing-choose-box">

        <div className="washing-choose-icon">
          ⚙️
        </div>

        <h2>
          Quality Replacement Parts
        </h2>

      </div>

      {/* BOX 6 */}

      <div className="washing-choose-box">

        <div className="washing-choose-icon">
          👨‍🔧
        </div>

        <h2>
          Experienced Technicians
        </h2>

      </div>

    </div>

  </div>

</section>
{/* WASHING MACHINE REQUEST INFO */}

<section className="washing-request-section">

  {/* Left Content */}

  <div className="washing-request-left">

    <h1>
      Washing Machine <br />
      Repair Support
    </h1>

    <h2>
      Fast & Reliable Washing <br />
      Machine Service at <br />
      Your Doorstep
    </h2>

    <p>
      We provide complete washing machine repair and maintenance solutions
      for all major brands. Our experienced technicians handle fully automatic,
      semi automatic, drainage, spinning, motor, and installation issues with
      professional doorstep support and affordable pricing.
    </p>

  </div>

  {/* Right Image */}

  <div className="washing-request-right">

    <img
      src={washingrepair}
      alt="washing machine service"
    />

  </div>

</section>

{/* WASHING MACHINE CUSTOMER SUPPORT */}

{/* <section className="washing-support-section">



  <div className="washing-support-image">

    <img
      src={customer}  alt="customer support"
    />

  </div>

 

  <div className="washing-support-content">

    <h1>
      Customer Support
    </h1>

   
    <div className="washing-support-box">
      <span>+</span>
      <p>Quick Booking Through Call & WhatsApp</p>
    </div>

    <div className="washing-support-box">
      <span>+</span>
      <p>Same Day Technician Visit</p>
    </div>

    <div className="washing-support-box">
      <span>+</span>
      <p>Professional Multi-Brand Support</p>
    </div>

    <div className="washing-support-box">
      <span>+</span>
      <p>Experienced Repair Technicians</p>
    </div>

    <div className="washing-support-box">
      <span>+</span>
      <p>Affordable Service Charges</p>
    </div>

  </div>

</section> */}

<section class="working-hours-section">
  <div class="container">
    <div class="working-hours-box">
      <h2>Working Hours</h2>

      <div class="working-time">
        <span>Monday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Tuesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Wednesday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Thursday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Friday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Saturday</span>
        <strong>07:00 AM – 09:00 PM</strong>
      </div>

      <div class="working-time">
        <span>Sunday</span>
        <strong>Closed</strong>
      </div>
    </div>
  </div>
</section>



<section className="service-info-section">
  <div className="service-info-container">

    <div className="service-info-header">
      <span>SERVICE DETAILS</span>
      <h2>Service Information</h2>

      <p>
        Clear information about our service charges and repair process.
      </p>
    </div>

    <div className="service-charge-box">

      <div className="service-check-icon">
        ✓
      </div>

      <div className="service-charge-content">

        <h3>Service Charge</h3>

        <div className="service-price">
          ₹400+
        </div>

        <p>
          The applicable basic service charge starts from ₹400.
          If any spare parts need replacement, our technician will
          explain the issue and inform you of the applicable cost
          before proceeding.
        </p>

        <div className="service-approval-note">
          <span>✓</span>

          <p>
            Spare part replacement or additional repair work will be
            carried out only after receiving your approval.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>

    </>
  );
}

export default WashingMachineService;